
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class SanityLink extends Vue {
  @Prop(String)
  readonly href!: string;
  @Prop(Boolean)
  readonly blank!: boolean;

  get isExternalLink() {
    if (/^https?:\/\//.test(this.href) || /^(tel)|(mailto):/.test(this.href)) {
      return true;
    }
    return false;
  }

  get target() {
    return this.blank ? '_blank' : '_top';
  }
}
